var HG = {};

HG.EventTracking = {
    'init': function() {
        $('a').each(function(){
            $(this).on('click', function() {
                HG.EventTracking.fireGAEvent($(this));
            });
        });
    },
    'fireGAEvent': function(elem) {
        if(elem) {
            var google_event_type = elem.data('ga-category');
            var event_action = elem.data('ga-action');
            var event_label = elem.data('ga-label');

            if(google_event_type && event_action && event_label) {
                if (typeof(pageTracker) != 'undefined') {
                    pageTracker._trackEvent(google_event_type, event_action, event_label);
                }
            }
        }
    }
};


// WEBPACK FOOTER //
// ../legacy/src/js/HG.EventTracking.js